<template>
  <div class="print-processed">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>已处理的打印申请-整车保</span>
      </div>
      
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          
          <el-form-item label="申请类型">
            <el-select v-model="searchForm.type" placeholder="请选择类型">
              <el-option label="发票" value="1"></el-option>
              <el-option label="专用发票" value="4"></el-option>
              <el-option label="保单" value="2"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="公司名称">
            <el-input v-model="searchForm.companyName" placeholder="公司名称" clearable></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column prop="company" label="申请公司" width="280" align="center"></el-table-column>
        <el-table-column prop="amount" label="打印金额" width="100" :formatter="moneyFormat" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" width="80" :formatter="typeFormat" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" :formatter="statusFormat" align="center"></el-table-column>
        <el-table-column prop="created_at" label="申请日期" width="260" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="deliverer" label="快递公司" width="110" align="center"></el-table-column>
        <el-table-column prop="tracking_no" label="快递单号" width="130" align="center"></el-table-column>
        <el-table-column prop="process_date" label="打印日期" width="260" :formatter="dateFormat" align="center"></el-table-column>
        <el-table-column prop="operator" label="处理人" width="120" align="center"></el-table-column>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleView(scope.row)">查看</el-button>
            <el-button v-if="scope.row.type !== 2" size="mini" @click="handleExportExcel(scope.row.id)">导出Excel</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" width="180" align="center"></el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { formatDate, formatMoney } from '@/utils/formatter'
import { getZcbPrintProcessedList, getZcbPrintInfo } from '@/api/member'
import ExportJsonExcel from 'js-export-excel'

export default {
  name: 'PrintProcessed',
  data() {
    return {
      loading: false,
      searchForm: {
        dateRange: [],
        type: '',
        companyName: ''
      },
      tableData: [],
      multipleSelection: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          status: 4, // 已处理状态
          ...this.buildSearchParams()
        }
        
        const res = await getZcbPrintProcessedList(params)
        this.tableData = res.rows || []
        this.pagination.total = res.total || 0
      } catch (error) {
        console.error('获取已处理打印申请列表失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.start_time = Math.floor(this.searchForm.dateRange[0] / 1000)
        params.end_time = Math.floor(this.searchForm.dateRange[1] / 1000)
      }
      if (this.searchForm.type) params.type = this.searchForm.type
      if (this.searchForm.companyName) params.company = this.searchForm.companyName
      
      return params
    },
    
    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        dateRange: [],
        type: '',
        companyName: ''
      }
      this.pagination.currentPage = 1
      this.fetchData()
    },
    
    // 查看详情
    async handleView(row) {
      try {
        const res = await getZcbPrintInfo({ id: row.id })
        if (res.err_code === 0) {
          // 这里可以打开一个详情对话框显示详细信息
          this.$message.info(`查看ID为${row.id}的详情`)
        } else {
          this.$message.error(res.err_msg || '获取详情失败')
        }
      } catch (error) {
        console.error('获取打印申请详情失败:', error)
        this.$message.error('获取详情失败')
      }
    },
    
    // 导出Excel
    async handleExportExcel(id) {
      try {
        const res = await getZcbPrintInfo({ id: id })
        if (res.err_code === 0) {
          // 使用ExportJsonExcel导出数据
          const exportExcel = new ExportJsonExcel({
            fileName: '发票订单列表',
            datas: [{
              sheetData: res.data.orders_detail.map(item => ({
                '保单号': item.policy_no,
                '原价(元)': formatMoney(item.price),
                '实付金额(元)': formatMoney(item.pay_price),
                '红包金额': formatMoney(item.discount),
                '创建时间': formatDate(item.created_at),
                '生效时间': formatDate(item.effected_at)
              })),
              sheetName: 'sheet'
            }]
          })
          exportExcel.saveExcel()
          this.$message.success('导出成功')
        } else {
          this.$message.error(res.err_msg || '导出失败')
        }
      } catch (error) {
        console.error('导出Excel失败:', error)
        this.$message.error('导出失败')
      }
    },
    
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    
    // 金额格式化
    moneyFormat(row, column, cellValue) {
      return formatMoney(cellValue)
    },
    
    // 类型格式化
    typeFormat(row, column, cellValue) {
      const typeMap = {
        1: '普通发票',
        2: '协议',
        4: '专用发票'
      }
      return typeMap[cellValue] || ''
    },
    
    // 状态格式化
    statusFormat(row, column, cellValue) {
      const statusMap = {
        1: '待处理',
        2: '处理中',
        4: '已处理'
      }
      return statusMap[cellValue] || ''
    },
    
    // 日期格式化
    dateFormat(row, column, cellValue) {
      return formatDate(cellValue)
    }
  }
}
</script>

<style lang="less" scoped>
.print-processed {
  padding: 20px;
  
  .search-toolbar {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .content {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    p {
      font-size: 18px;
      color: #666;
    }
  }
}
</style>
